import {
  useUpdateAgent,
  useGetAgent,
  getAgentsKey,
  getAgentKey,
} from 'api-hooks/agent';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import { queryClient } from 'common/repositories/query-client';
import LoadingComponent from 'components/common/loading';
import notification from 'components/common/notification';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import { DetailContainer, SeparatorVertical } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import * as React from 'react';
import { NavigationProps } from 'types';

import AgentForm from './components/form';

export type AgentViewParams = {
  id: string;
};

export default function AgentView(
  props: NavigationProps<NavigationRoutes.AgentsView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } = useGetAgent({
    id,
  });
  const { mutateAsync, error: errorMutate } = useUpdateAgent();

  const agent = data?.data;

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <>
          {!!errorMutate && !!errorMutate.message && (
            <>
              <Notification
                overrides={{
                  Body: { style: { width: 'auto', wordBreak: 'break-all' } },
                }}
                kind={KIND.negative}
                closeable
              >
                {() => errorMutate.message}
              </Notification>
              <SeparatorVertical $margin={8} />
            </>
          )}
          <AgentForm
            {...props}
            agent={agent}
            onSubmit={async (input, form) => {
              const result = await mutateAsync({
                body: input,
                agentId: agent!.id,
              });

              queryClient.refetchQueries([getAgentsKey()[0]]);
              queryClient.refetchQueries(getAgentKey({ id: result.data.id }));

              notification.success({ message: result?.message });

              return result.data;
            }}
          />
        </>
      }
    />
  );
}
